export { default as awsService } from './awsService';
